module.exports = __webpack_public_path__ + "img/1485169920.1e7d9a64.jpg";